import { actionChannel, call, fork, put, take, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnLoadActions } from '../../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../../http_requests_on_success';
import { httpRequestsOnErrorsActions } from '../../http_requests_on_errors';
import {
    ADD_SINGLE_TARGET_MAINTENANCE_STEP,
    ADD_TARGET_MAINTENANCE_STEP,
    CHANGE_GOAL_MASTERY,
    CHANGE_MAINTENANCE_STEP,
    CHANGE_SINGLE_TARGET_MAINTENANCE,
    CHANGE_SINGLE_TARGET_MASTERY,
    CHANGE_TARGET_MAINTENANCE,
    CHANGE_TARGET_MASTERY,
    CHOOSE_GOALS_FROM_LIBRARY,
    CHOOSE_OPTIONS_FROM_LIBRARY,
    CHOOSE_TARGETS_FROM_LIBRARY,
    CLONE_GOAL,
    CREATE_GOAL,
    CREATE_OPTION,
    CREATE_TARGET,
    CREATE_SECTION_TYPE,
    DELETE_GOAL,
    UPSERT_SECTION_DESCRIPTION_BLOCK,
    DELETE_SECTION_DESCRIPTION_BLOCK,
    REORDER_SECTION_DESCRIPTION_BLOCKS,
    DELETE_OPTION,
    RESTORE_GOAL,
    RESTORE_OPTION,
    DELETE_SINGLE_TARGET_MAINTENANCE_STEP,
    DELETE_TARGET_MAINTENANCE_STEP,
    EDIT_GOAL,
    EDIT_GOAL_STATUS,
    EDIT_OPTION,
    EDIT_SECTION_TYPE,
    EDIT_SINGLE_TARGET_MAINTENANCE_STEP,
    EDIT_TARGET,
    DELETE_TARGET,
    RESTORE_TARGET,
    EDIT_TARGET_TRANSITION_DATE,
    EDIT_TARGET_MAINTENANCE_STEP,
    GET_GOAL_BY_ID,
    GET_GOAL_BY_ID_SUCCESS,
    GET_SECTION_TYPES,
    GET_SECTION_TYPES_SUCCESS,
    GET_GOAL_GRAPH,
    GET_GOAL_GRAPH_SUCCESS,
    GET_GOAL_SESSIONS,
    GET_GOAL_SESSIONS_SUCCESS,
    GET_GOAL_TRIAL_DATA,
    GET_GOAL_TRIAL_DATA_SUCCESS,
    GET_GOALS,
    GET_GOALS_FOR_SESSION,
    GET_GOALS_FOR_SESSION_SUCCESS,
    GET_GOALS_SUCCESS,
    GET_TARGET_CHART_DATA,
    GET_TARGET_CHART_DATA_SUCCESS,
    REMOVE_SINGLE_TARGET_MASTERY,
    CHANGE_BASELINE_CRITERIA,
    CHANGE_SINGLE_TARGET_BASELINE_CRITERIA,
    SINGLE_TARGET_BASELINE_FOLLOW_GOAL,
    REMOVE_SINGLE_TARGET_BASELINE_CRITERIA,
    REORDER_OPTION,
    REORDER_TARGET,
    SINGLE_TARGET_FOLLOW_GOAL_CONFIG,
    SINGLE_TARGET_MASTERY_FOLLOW_GOAL,
    GET_SIMPLE_GOALS,
    GET_SIMPLE_GOALS_SUCCESS,
    GET_GOAL_CLINICAL_DATA,
    GET_GOAL_CLINICAL_DATA_SUCCESS,
    GET_GOAL_CLINICAL_DEFAULT_VALUES,
    GET_GOAL_CLINICAL_DEFAULT_VALUES_SUCCESS,
    GET_GOAL_TARGET_CLINICAL_DATA,
    GET_GOAL_TARGET_CLINICAL_DATA_SUCCESS,
} from './goal.types';
import { authService } from './goal.service';
import { toast } from 'react-toastify';
import { NotError } from '../../../components';
import React from 'react';

/** Goals */

function* getGoals({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(authService.getGoalsService, payload?.params);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getGoalsForSession({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(authService.getGoalsForSessionService, payload?.clientId, payload?.params);
        yield put({
            type: GET_GOALS_FOR_SESSION_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getSimpleGoals({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(authService.getSimpleGoalsService, payload?.clientId, payload?.params);
        yield put({
            type: GET_SIMPLE_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* chooseGoalsFromLibrary({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(authService.chooseGoalsFromLibraryService, payload?.body);
        const res = yield call(authService.getGoalsService, payload?.requestParams);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}
function* chooseTargetsFromLibrary({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(authService.chooseTargetsFromLibraryService, payload?.goalId, payload?.body);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* chooseOptionsFromLibrary({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(authService.chooseOptionsFromLibraryService, payload?.goalId, payload?.body);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getGoalById({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(authService.getGoalByIdService, payload?.id);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getSectionTypes({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(authService.getSectionTypesService);
        yield put({
            type: GET_SECTION_TYPES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put({
            type: GET_SECTION_TYPES_SUCCESS,
            payload: [],
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* createSectionType({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.createSectionTypeService, payload?.body);
        const res = yield call(authService.getSectionTypesService);
        yield put({
            type: GET_SECTION_TYPES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* editSectionType({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.editSectionTypeService, payload?.id, payload?.body);
        const res = yield call(authService.getSectionTypesService);
        yield put({
            type: GET_SECTION_TYPES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* createGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const newGoal = yield call(authService.createGoalService, payload?.body);
        const res = yield call(authService.getGoalsService, payload?.requestParams);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, newGoal?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* editGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.editGoalService, payload?.id, payload?.body);

        const goalById = yield call(authService.getGoalByIdService, payload?.id);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        const res = yield call(authService.getGoalsService, payload?.requestParams);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, goalById?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* upsertSectionDescriptionBlock({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.upsertSectionDescriptionBlockService, payload?.goalId, payload?.body);
        const goalById = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });
        const res = yield call(authService.getGoalsService, payload?.requestParams);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* deleteSectionDescriptionBlock({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.deleteSectionDescriptionBlockService, payload?.goalId, payload?.sectionTypeId);
        const goalById = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });
        const res = yield call(authService.getGoalsService, payload?.requestParams);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* reorderSectionDescriptionBlocks({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.reorderSectionDescriptionBlocksService, payload?.goal?.id, payload?.reorder);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        // The reducer applied the move optimistically — reload the goal to restore the saved order.
        try {
            const goalById = yield call(authService.getGoalByIdService, payload?.goal?.id);
            yield put({
                type: GET_GOAL_BY_ID_SUCCESS,
                payload: goalById.data,
            });
        } catch (e) {}
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

/** Each reorder is a move relative to the previous order, so requests must reach the API one at a time, in order */
function* watchReorderSectionDescriptionBlocks() {
    const channel = yield actionChannel(REORDER_SECTION_DESCRIPTION_BLOCKS);
    while (true) {
        const action = yield take(channel);
        yield call(reorderSectionDescriptionBlocks, action);
    }
}

function* editGoalStatus({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.editGoalStatusService, payload?.id, payload?.status);
        const goalById = yield call(authService.getGoalByIdService, payload?.id);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        const res = yield call(authService.getGoalsService, payload?.requestParams);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* deleteGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.deleteGoalService, payload?.id);
        const res = yield call(authService.getGoalsService, payload?.requestParams);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* restoreGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.restoreGoalService, payload?.id);
        const res = yield call(authService.getGoalsService, payload?.requestParams);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* restoreOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.restoreOptionService, payload?.goalId, payload?.optionId);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* cloneGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const clonedGoal = yield call(authService.cloneGoalService, payload?.id, payload?.data);
        const res = yield call(authService.getGoalsService, payload?.requestParams);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, clonedGoal?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* getGoalSessions({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.getGoalSessionsService, payload?.goalId);
        yield put({
            type: GET_GOAL_SESSIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put({
            type: GET_GOAL_SESSIONS_SUCCESS,
            payload: [],
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getGoalGraph({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.getGoalGraphService, payload?.goalId, payload?.params);
        yield put({
            type: GET_GOAL_GRAPH_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put({
            type: GET_GOAL_SESSIONS_SUCCESS,
            payload: {},
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}
function* getGoalTrialData({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.getGoalTrialDataService, payload?.goalId, payload?.sessionId);
        yield put({
            type: GET_GOAL_TRIAL_DATA_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

/** Targets */

function* createTarget({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.createTargetService, payload?.goalId, payload?.body);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));

        const allGoals = yield call(authService.getGoalsService, payload?.requestParams);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: allGoals?.data,
        });
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* editTarget({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.editTargetService, payload?.goalId, payload?.targetId, payload?.body);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));

        const allGoals = yield call(authService.getGoalsService, payload?.requestParams);
        yield put({
            type: GET_GOALS_SUCCESS,
            payload: allGoals?.data,
        });
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** Delete / restore a target: the goal reloads, and so does the goals list (its target counts change). */
function* changeTargetDeletion(serviceCall, { payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(serviceCall, payload?.goalId, payload?.targetId);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));

        if (payload?.requestParams) {
            const allGoals = yield call(authService.getGoalsService, payload.requestParams);
            yield put({
                type: GET_GOALS_SUCCESS,
                payload: allGoals?.data,
            });
        }
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* deleteTarget(action) {
    yield* changeTargetDeletion(authService.deleteTargetService, action);
}

function* restoreTarget(action) {
    yield* changeTargetDeletion(authService.restoreTargetService, action);
}

/** "Last Transitioned" edit: the endpoint returns the goal, then the goals table is refreshed. */
function* editTargetTransitionDate({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.editTargetTransitionDateService, payload?.goalId, payload?.targetId, {
            date: payload?.date,
        });
        yield put({ type: GET_GOAL_BY_ID_SUCCESS, payload: res.data });
        if (payload?.requestParams) {
            const allGoals = yield call(authService.getGoalsService, payload?.requestParams);
            yield put({ type: GET_GOALS_SUCCESS, payload: allGoals?.data });
        }
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* reorderTarget({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.reorderTargetService, payload?.goal?.id, payload?.reorder);
        const res = yield call(authService.getGoalByIdService, payload?.goal?.id);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getTargetChartData({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.getTargetChartDataService, payload?.clientId, payload?.params);
        yield put({
            type: GET_TARGET_CHART_DATA_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

/** Options */

function* createOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.createOptionService, payload?.goalId, payload?.body);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* editOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.editOptionService, payload?.goalId, payload?.optionId, payload?.body);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* deleteOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.deleteOptionService, payload?.goalId, payload?.optionId);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* reorderOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.reorderOrderService, payload?.goal?.id, payload?.reorder);
        const res = yield call(authService.getGoalByIdService, payload?.goal?.id);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

/** Mastery */
function* changeTargetMastery({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.changeTargetMasteryService, payload?.goalId, payload?.body);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* changeGoalMastery({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.changeGoalMasteryService, payload?.goalId, payload?.body);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* changeSingleTargetMastery({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.changeSingleTargetMasteryService, payload?.goalId, payload?.targetId, payload?.body);
        // const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}
function* singleTargetMasteryFollowGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.singleTargetMasteryFollowGoalService, payload?.goalId, payload?.targetId, payload?.body);
        // const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* removeSingleTargetMastery({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.removeSingleTargetMasteryService, payload?.goalId, payload?.targetId);
        // const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** Baseline -> Teaching criteria */
function* changeBaselineCriteria({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.changeBaselineCriteriaService, payload?.goalId, payload?.body);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* changeSingleTargetBaselineCriteria({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(
            authService.changeSingleTargetBaselineCriteriaService,
            payload?.goalId,
            payload?.targetId,
            payload?.body
        );
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* singleTargetBaselineFollowGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(
            authService.singleTargetBaselineFollowGoalService,
            payload?.goalId,
            payload?.targetId,
            payload?.body
        );
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* removeSingleTargetBaselineCriteria({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.removeSingleTargetBaselineCriteriaService, payload?.goalId, payload?.targetId);
        const res = yield call(authService.getGoalByIdService, payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* changeSingleTargetMaintenance(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(
            authService.changeSingleTargetMaintenanceService,
            action?.payload?.goalId,
            action?.payload?.targetId,
            action?.payload?.body
        );
        const res = yield call(authService.getGoalByIdService, action?.payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* addSingleTargetMaintenanceStep(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(
            authService.addSingleTargetMaintenanceStepService,
            action?.payload?.goalId,
            action?.payload?.targetId,
            action?.payload?.body
        );
        const res = yield call(authService.getGoalByIdService, action?.payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* editSingleTargetMaintenanceStep(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(
            authService.editSingleTargetMaintenanceStepService,
            action?.payload?.goalId,
            action?.payload?.stepId,
            action?.payload?.body
        );
        const res = yield call(authService.getGoalByIdService, action?.payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* singleTargetFollowGoalConfig(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(
            authService.singleTargetFollowGoalConfigService,
            action?.payload?.goalId,
            action?.payload?.targetId,
            action?.payload?.body
        );
        const res = yield call(authService.getGoalByIdService, action?.payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteSingleTargetMaintenanceStep(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(
            authService.deleteSingleTargetMaintenanceStepService,
            action?.payload?.goalId,
            action?.payload?.targetId,
            action?.payload?.stepId
        );
        const res = yield call(authService.getGoalByIdService, action?.payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* changeMaintenanceStep(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.changeMaintenanceStepService, action?.payload?.goalId, action?.payload?.params);
        const res = yield call(authService.getGoalByIdService, action?.payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Target Maintenance */

function* changeTargetMaintenance(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.changeTargetMaintenanceService, action?.payload?.goalId, action?.payload?.body);
        const res = yield call(authService.getGoalByIdService, action?.payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* addTargetMaintenanceStep(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.addTargetMaintenanceStepService, action?.payload?.goalId, action?.payload?.body);
        const res = yield call(authService.getGoalByIdService, action?.payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* editTargetMaintenanceStep(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.editTargetMaintenanceStepService, action?.payload?.goalId, action?.payload?.stepId, action?.payload?.body);
        const res = yield call(authService.getGoalByIdService, action?.payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteTargetMaintenanceStep(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.deleteTargetMaintenanceStepService, action?.payload?.goalId, action?.payload?.stepId);
        const res = yield call(authService.getGoalByIdService, action?.payload?.goalId);
        yield put({
            type: GET_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Goal Clinical Data */
function* getGoalClinicalData(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getGoalCumulativeService, action?.payload?.params);
        yield put({
            type: GET_GOAL_CLINICAL_DATA_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_GOAL_CLINICAL_DATA_SUCCESS,
            payload: [],
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* getGoalTargetClinicalData(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));

    try {
        const res = yield call(authService.getGoalTargetClinicalDataService, action?.payload?.params, action?.payload?.clientId);
        const addClientEventsToGoals = (goals, clientEvents) => {
            return Object.fromEntries(Object.entries(goals || {}).map(([id, goal]) => [id, { ...goal, clientEvents }]));
        };

        const goalsWithEvents = addClientEventsToGoals(res?.data?.goals, res?.data?.clientEvents);

        yield put({
            type: GET_GOAL_TARGET_CLINICAL_DATA_SUCCESS,
            payload: goalsWithEvents,
        });

        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_GOAL_TARGET_CLINICAL_DATA_SUCCESS,
            payload: [],
        });

        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getGoalClinicalDefaultValues(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getGoalClinicalDefaultValuesService, action?.payload?.params);
        yield put({
            type: GET_GOAL_CLINICAL_DEFAULT_VALUES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_GOAL_CLINICAL_DEFAULT_VALUES_SUCCESS,
            payload: [],
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

export const watchGoals = function* watchGoalsAuth() {
    /** Goals  */
    yield takeLatest(GET_GOALS, getGoals);
    yield takeLatest(GET_GOALS_FOR_SESSION, getGoalsForSession);
    yield takeLatest(GET_SIMPLE_GOALS, getSimpleGoals);
    yield takeLatest(CHOOSE_GOALS_FROM_LIBRARY, chooseGoalsFromLibrary);
    yield takeLatest(CHOOSE_OPTIONS_FROM_LIBRARY, chooseOptionsFromLibrary);
    yield takeLatest(CHOOSE_TARGETS_FROM_LIBRARY, chooseTargetsFromLibrary);
    yield takeLatest(GET_GOAL_BY_ID, getGoalById);
    yield takeLatest(GET_SECTION_TYPES, getSectionTypes);
    yield takeLatest(CREATE_GOAL, createGoal);
    yield takeLatest(EDIT_GOAL, editGoal);
    yield takeLatest(UPSERT_SECTION_DESCRIPTION_BLOCK, upsertSectionDescriptionBlock);
    yield takeLatest(DELETE_SECTION_DESCRIPTION_BLOCK, deleteSectionDescriptionBlock);
    yield fork(watchReorderSectionDescriptionBlocks);
    yield takeLatest(EDIT_GOAL_STATUS, editGoalStatus);
    yield takeLatest(DELETE_GOAL, deleteGoal);
    yield takeLatest(CLONE_GOAL, cloneGoal);
    yield takeLatest(GET_GOAL_SESSIONS, getGoalSessions);
    yield takeLatest(GET_GOAL_GRAPH, getGoalGraph);
    yield takeLatest(GET_GOAL_TRIAL_DATA, getGoalTrialData);
    /** End */

    /** Targets */
    yield takeLatest(CREATE_TARGET, createTarget);
    yield takeLatest(EDIT_TARGET, editTarget);
    yield takeLatest(DELETE_TARGET, deleteTarget);
    yield takeLatest(RESTORE_TARGET, restoreTarget);
    yield takeLatest(EDIT_TARGET_TRANSITION_DATE, editTargetTransitionDate);
    yield takeLatest(REORDER_TARGET, reorderTarget);
    yield takeLatest(GET_TARGET_CHART_DATA, getTargetChartData);
    /** End */

    /** Options */
    yield takeLatest(CREATE_OPTION, createOption);
    yield takeLatest(EDIT_OPTION, editOption);
    yield takeLatest(DELETE_OPTION, deleteOption);
    yield takeLatest(RESTORE_GOAL, restoreGoal);
    yield takeLatest(RESTORE_OPTION, restoreOption);
    yield takeLatest(REORDER_OPTION, reorderOption);
    /** End */

    /** Mastery */
    yield takeLatest(CHANGE_TARGET_MASTERY, changeTargetMastery);
    yield takeLatest(CHANGE_GOAL_MASTERY, changeGoalMastery);
    yield takeLatest(CHANGE_SINGLE_TARGET_MASTERY, changeSingleTargetMastery);
    yield takeLatest(SINGLE_TARGET_MASTERY_FOLLOW_GOAL, singleTargetMasteryFollowGoal);
    yield takeLatest(REMOVE_SINGLE_TARGET_MASTERY, removeSingleTargetMastery);
    yield takeLatest(CHANGE_BASELINE_CRITERIA, changeBaselineCriteria);
    yield takeLatest(CHANGE_SINGLE_TARGET_BASELINE_CRITERIA, changeSingleTargetBaselineCriteria);
    yield takeLatest(SINGLE_TARGET_BASELINE_FOLLOW_GOAL, singleTargetBaselineFollowGoal);
    yield takeLatest(REMOVE_SINGLE_TARGET_BASELINE_CRITERIA, removeSingleTargetBaselineCriteria);

    yield takeLatest(CHANGE_SINGLE_TARGET_MAINTENANCE, changeSingleTargetMaintenance);
    yield takeLatest(ADD_SINGLE_TARGET_MAINTENANCE_STEP, addSingleTargetMaintenanceStep);
    yield takeLatest(EDIT_SINGLE_TARGET_MAINTENANCE_STEP, editSingleTargetMaintenanceStep);
    yield takeLatest(SINGLE_TARGET_FOLLOW_GOAL_CONFIG, singleTargetFollowGoalConfig);
    yield takeLatest(DELETE_SINGLE_TARGET_MAINTENANCE_STEP, deleteSingleTargetMaintenanceStep);
    yield takeLatest(CHANGE_MAINTENANCE_STEP, changeMaintenanceStep);
    /** End */

    /** Target Maintenance */
    yield takeLatest(CHANGE_TARGET_MAINTENANCE, changeTargetMaintenance);
    yield takeLatest(ADD_TARGET_MAINTENANCE_STEP, addTargetMaintenanceStep);
    yield takeLatest(EDIT_TARGET_MAINTENANCE_STEP, editTargetMaintenanceStep);
    yield takeLatest(DELETE_TARGET_MAINTENANCE_STEP, deleteTargetMaintenanceStep);
    /** End */

    /** Goal Clinical Data */
    yield takeLatest(GET_GOAL_CLINICAL_DATA, getGoalClinicalData);
    yield takeLatest(GET_GOAL_TARGET_CLINICAL_DATA, getGoalTargetClinicalData);
    yield takeLatest(GET_GOAL_CLINICAL_DEFAULT_VALUES, getGoalClinicalDefaultValues);
    /** End */

    /** Section Types */
    yield takeLatest(CREATE_SECTION_TYPE, createSectionType);
    yield takeLatest(EDIT_SECTION_TYPE, editSectionType);
    /** End */
};
